if (!customElements.get('cart-drawer')) {
  class CartDrawer extends HTMLElement {
    constructor() {
      super();

      this.addEventListener("keyup", (evt) => evt.code === "Escape" && this.close());
      this.querySelector("#CartDrawer-Overlay").addEventListener("click", this.close.bind(this));
      this.setHeaderCartIconAccessibility();
      this.bindUpsellButton();
    }

    setHeaderCartIconAccessibility() {
      const cartLink = document.querySelector("#cart-icon-bubble");
      if (!cartLink) return;

      cartLink.setAttribute("role", "button");
      cartLink.setAttribute("aria-haspopup", "dialog");
      cartLink.addEventListener("click", (event) => {
        event.preventDefault();
        this.open(cartLink);
      });
      cartLink.addEventListener("keydown", (event) => {
        if (event.code.toUpperCase() === "SPACE") {
          event.preventDefault();
          this.open(cartLink);
        }
      });
    }

    bindUpsellButton() {
      this.addEventListener("click", (event) => {
        const upsellButton = event.target.closest(".upsell-add-button");
        if (upsellButton) {
          event.preventDefault();

          const form = upsellButton.closest(".upsell-form");
          const variantId = form.querySelector('input[name="id"]').value;

          this.addItemToCart(variantId);
        }
      });
    }

    async addItemToCart(variantId) {
      const sections = this.getSectionsToRender().map((section) => section.id);

      const body = JSON.stringify({
        id: variantId,
        quantity: 1,
        sections: sections,
        sections_url: window.location.pathname,
      });

      try {
        const response = await fetch(`${routes.cart_add_url}`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: `application/json`,
          },
          body,
        });

        if (response.status === 422) {
          const errorData = await response.json();
          console.error("Error adding item to cart:", JSON.stringify(errorData), "| variantId=", variantId);
          return;
        }

        const parsedState = await response.json();
        this.renderContents(parsedState);
      } catch (error) {
        console.error("Error adding item to cart:", error);
      }
    }

    startCountdownTimer() {
      const timerElement = document.getElementById("cart-countdown-timer");
      if (!timerElement) return;

      let minutes = 10;
      let seconds = 0;

      if (this.countdownInterval) {
        clearInterval(this.countdownInterval);
      }

      const updateTimer = () => {
        timerElement.textContent = `${minutes.toString().padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
      };

      updateTimer();

      this.countdownInterval = setInterval(() => {
        if (seconds === 0) {
          if (minutes === 0) {
            clearInterval(this.countdownInterval);
            return;
          }
          minutes--;
          seconds = 59;
        } else {
          seconds--;
        }

        updateTimer();
      }, 1000);
    }

    open(triggeredBy) {
      if (triggeredBy) this.setActiveElement(triggeredBy);
      const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
      if (cartDrawerNote && !cartDrawerNote.hasAttribute("role")) this.setSummaryAccessibility(cartDrawerNote);
      setTimeout(() => {
        this.classList.add("animate", "active");
      });

      this.addEventListener(
        "transitionend",
        () => {
          const containerToTrapFocusOn = this.classList.contains("is-empty")
            ? this.querySelector(".drawer__inner-empty")
            : document.getElementById("CartDrawer");
          const focusElement = this.querySelector(".drawer__inner") || this.querySelector(".drawer__close");
          trapFocus(containerToTrapFocusOn, focusElement);
        },
        { once: true },
      );

      document.body.classList.add("overflow-hidden");

      if (typeof $ !== "undefined" && typeof $.fn.slick !== "undefined") {
        const $slider = $(".gbfrequently-bought-with-main-whole-slider");
        if ($slider.length > 0) {
          $slider.slick({
            infinite: true,
            autoplaySpeed: 1000,
            autoplay: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            dots: true,
          });
          $slider.css("opacity", "1");
        }
      }

      this.startCountdownTimer();
    }

    close() {
      const cartCustomizationMode = document.querySelector("cart-drawer").classList.contains("customization-mode");
      if (cartCustomizationMode) {
        alert("Cart Customization Mode is active. Disable it in Theme Settings > Cart Drawer to allow closing.");
        return;
      }

      this.classList.remove("active");
      removeTrapFocus(this.activeElement);
      document.body.classList.remove("overflow-hidden");

      if (this.countdownInterval) {
        clearInterval(this.countdownInterval);
      }
    }

    setSummaryAccessibility(cartDrawerNote) {
      cartDrawerNote.setAttribute("role", "button");
      cartDrawerNote.setAttribute("aria-expanded", "false");

      if (cartDrawerNote.nextElementSibling.getAttribute("id")) {
        cartDrawerNote.setAttribute("aria-controls", cartDrawerNote.nextElementSibling.id);
      }

      cartDrawerNote.addEventListener("click", (event) => {
        event.currentTarget.setAttribute("aria-expanded", !event.currentTarget.closest("details").hasAttribute("open"));
      });

      cartDrawerNote.parentElement.addEventListener("keyup", onKeyUpEscape);
    }

    renderContents(parsedState) {
      this.querySelector(".drawer__inner").classList.contains("is-empty") &&
        this.querySelector(".drawer__inner").classList.remove("is-empty");
      this.productId = parsedState.id;
      this.getSectionsToRender().forEach((section) => {
        const sectionElement = section.selector
          ? document.querySelector(section.selector)
          : document.getElementById(section.id);

        if (!sectionElement) return;
        if (section.id == "cart-drawer" || section.selector == "#CartDrawer") {
          const newCartDrawer = this.getSectionDOM(parsedState.sections[section.id], section.selector);
          updateCartDrawer(sectionElement, newCartDrawer);
        } else {
          if (section.id === "cart-icon-bubble") {
            const iconType = sectionElement.getAttribute("data-cart-icon-type");
            sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
            if (iconType) {
              sectionElement.setAttribute("data-cart-icon-type", iconType);
            }
            const iconWrapper = sectionElement.querySelector(".svg-wrapper");
            if (iconWrapper && iconType) {
              const bagIcon = iconWrapper.querySelector(".cart-icon-bag");
              const cartIcon = iconWrapper.querySelector(".cart-icon-cart");
              const cartIconEmpty = iconWrapper.querySelector(".cart-icon-cart-empty");

              if (iconType === "bag") {
                if (bagIcon) bagIcon.style.display = "flex";
              } else {
                const cartEmpty = parsedState.item_count === 0;
                if (cartEmpty && cartIconEmpty) {
                  cartIconEmpty.style.display = "flex";
                } else if (cartIcon) {
                  cartIcon.style.display = "flex";
                }
              }
            }
          } else {
            sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
          }
        }
      });

      setTimeout(() => {
        this.querySelector("#CartDrawer-Overlay").addEventListener("click", this.close.bind(this));
        this.open();
      });

      if (typeof $ !== "undefined" && typeof $.fn.slick !== "undefined") {
        const $slider = $(".gbfrequently-bought-with-main-whole-slider");
        if ($slider.length > 0) {
          $slider.slick({
            infinite: true,
            autoplaySpeed: 1000,
            autoplay: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            dots: true,
          });
          $slider.css("opacity", "1");
        }
      }
    }

    getSectionInnerHTML(html, selector = ".shopify-section") {
      return new DOMParser().parseFromString(html, "text/html").querySelector(selector).innerHTML;
    }

    getSectionsToRender() {
      setTimeout(function () {
        if (typeof $ !== "undefined" && typeof $.fn.slick !== "undefined") {
          var $slider = $(".gbfrequently-bought-with-main-whole-slider");
          if ($slider.length > 0 && !$slider.hasClass("slick-initialized")) {
            $slider.slick({
              infinite: true,
              autoplaySpeed: 1000,
              autoplay: false,
              slidesToShow: 1,
              slidesToScroll: 1,
              arrows: false,
              dots: true,
            });
            $slider.css("opacity", "1");
          }
        }
      }, 500);

      return [
        {
          id: "cart-drawer",
          selector: "#CartDrawer",
        },
        {
          id: "cart-icon-bubble",
        },
      ];
    }

    getSectionDOM(html, selector = ".shopify-section") {
      return new DOMParser().parseFromString(html, "text/html").querySelector(selector);
    }

    setActiveElement(element) {
      this.activeElement = element;
    }
  }

  customElements.define("cart-drawer", CartDrawer);
}

// Wait for CartItems to be defined before extending it
if (typeof CartItems !== "undefined") {
  defineCartDrawerItems();
} else {
  const checkCartItems = setInterval(() => {
    if (typeof CartItems !== "undefined") {
      clearInterval(checkCartItems);
      defineCartDrawerItems();
    }
  }, 50);
}

function defineCartDrawerItems() {
  if (customElements.get("cart-drawer-items")) {
    return;
  }

  class CartDrawerItems extends CartItems {
    getSectionsToRender() {
      setTimeout(function () {
        if (typeof $ !== "undefined" && typeof $.fn.slick !== "undefined") {
          const $slider = $(".gbfrequently-bought-with-main-whole-slider");
          if ($slider.length > 0) {
            $slider.slick({
              infinite: true,
              autoplaySpeed: 1000,
              autoplay: false,
              slidesToShow: 1,
              slidesToScroll: 1,
              arrows: false,
              dots: true,
            });
            $slider.css("opacity", "1");
          }
        }
      }, 500);

      return [
        {
          id: "CartDrawer",
          section: "cart-drawer",
          selector: ".drawer__inner",
        },
        {
          id: "cart-icon-bubble",
          section: "cart-icon-bubble",
          selector: ".shopify-section",
        },
      ];
    }
  }

  customElements.define("cart-drawer-items", CartDrawerItems);
}